import fetchService from "../lib/fetchService"
import { IMeeting } from "../lib/globalInterfaces"
import { WeekendDTO } from "./WeekendDTO"

export class SeasonDTO {
  year: number
  weekends: WeekendDTO[] = []

  constructor(options: IMeetingsDTO) {
    this.year = options.year
  }

  async load(year?: number) {
    if (year) {
      this.year = year
    }
    const data: IMeeting[] = await fetchService.get('/api/season/' + this.year)
    this.weekends = data.map(item => new WeekendDTO(item))
    return this.weekends
  }

  hasWeekend(circuit_short_name: string) {
    return this.weekends.some(race => race.circuit_short_name === circuit_short_name)
  }

  getWeekend(circuit_short_name: string) {
    return this.weekends.find(race => race.circuit_short_name === circuit_short_name)
  }

  getWeekends() {
    return this.weekends
  }
}

export interface IMeetingsDTO {
  year: number
}
